module.exports = __webpack_public_path__ + "static/glow-effect-3-0a43437bf338771eaf91141f6dc1cf10.png";